import React from "react";
import classnames from "classnames";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitch from "components/common/LanguageSwitch";

import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
} from "reactstrap";

const AuthNavbar = (props) => {
  const { t } = useTranslation("nav");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [color, setColor] = React.useState("navbar-transparent");

  const toggleCollapse = () => {
    if (collapseOpen) {
      setColor("navbar-transparent");
    } else {
      setColor("bg-white");
    }
    setCollapseOpen(!collapseOpen);
  };
  return (
    <Navbar className={classnames("fixed-top", color)} expand="lg">
      <Container fluid>
        <div className="navbar-wrapper">
          <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
            {props.brandText}
          </NavbarBrand>
          <LanguageSwitch className="ml-3" />
        </div>
        <button
          aria-controls="navigation-index"
          aria-expanded={false}
          aria-label={t("auth.toggleNavigation")}
          className="navbar-toggler"
          data-toggle="collapse"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
        </button>
        <Collapse isOpen={collapseOpen} navbar>
          <Nav navbar className="ml-auto">
            <NavItem>
              <NavLink to="/auth/register" className="nav-link">
                <i className="tim-icons icon-laptop" /> {t("auth.register")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/auth/login" className="nav-link">
                <i className="tim-icons icon-single-02" /> {t("auth.login")}
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink to="/auth/pricing" className="nav-link">
                <i className="tim-icons icon-coins" /> Pricing
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/auth/lock-screen" className="nav-link">
                <i className="tim-icons icon-lock-circle" /> Lock
              </NavLink>
            </NavItem> */}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default AuthNavbar;
